//
// Action types
//

export const SHOW_INFORMATION_WINDOW = "SHOW_INFORMATION_WINDOW";
export const HIDE_INFORMATION_WINDOW = "HIDE_INFORMATION_WINDOW";

//
// Action creators
//

export function showInformationWindow(mapKey, informationWindowId) {
  return {
    type: SHOW_INFORMATION_WINDOW,
    mapKey,
    informationWindowId
  };
}

export function hideInformationWindow(mapKey) {
  return {
    type: HIDE_INFORMATION_WINDOW,
    mapKey
  };
}

function showInformationWindowHandler(mapElementGeometryId) {
  return { mapElementGeometryId };
}

function hideInformationWindowHandler() {
  return {};
}

//
// Reducer and handlers
//

export function reduceInformationWindow(state, action) {
  switch (action && action.type) {
    case SHOW_INFORMATION_WINDOW:
      return showInformationWindowHandler(action.informationWindowId);

    case HIDE_INFORMATION_WINDOW:
      return hideInformationWindowHandler();

    default:
      return state || {};
  }
}
